import api, { NO_RETRY } from '@/services/api';

export interface SitePopup {
  id: string;
  name: string;
  badge: string;
  title: string;
  highlight: string;
  description: string;
  steps: string[];
  link_label: string;
  link_url: string;
  dismiss_mode: 'today' | 'forever';
  end_date: string | null;
  expires_at?: string | null;
}
export interface PopupConfig { revision: number; active_id: string | null; popups: SitePopup[] }
export const popupsApi = {
  async active(): Promise<SitePopup | null> {
    const response = await fetch('/api/popups/active', { cache: 'no-store' });
    if (!response.ok) throw new Error('공지를 불러오지 못했습니다.');
    return (await response.json()).popup;
  },
  async get(): Promise<PopupConfig> { return (await api.get('/api/admin/popups', NO_RETRY)).data; },
  async save(config: PopupConfig): Promise<PopupConfig> { return (await api.put('/api/admin/popups', config, NO_RETRY)).data; },
};
export function popupError(error: unknown): string {
  return (error as { response?: { data?: { error?: string } } })?.response?.data?.error || '팝업 설정을 처리하지 못했습니다. 다시 시도해 주세요.';
}
